define("shared/utils/constants/linkinbio-post-types", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  var PostTypes = /*#__PURE__*/function (PostTypes) {
    PostTypes["Later"] = "laterPost";
    PostTypes["Instagram"] = "igPost";
    PostTypes["Tiktok"] = "ttPost";
    PostTypes["Linkinbio"] = "linkinbioPost";
    PostTypes["Locked"] = "locked";
    return PostTypes;
  }(PostTypes || {});
  var _default = _exports.default = PostTypes;
});